import { Dispatch, useState } from 'react';
import { ActionIcon, Button, Group, Popover, MultiSelect } from '@mantine/core';
import { BiFilterAlt as FilterIcon } from 'react-icons/bi';
import { useIntlLight } from '../../../../../i18n';
import { actionTypes } from '../../../../types';
import { selectDropdownStyles } from './getSelectDropdownStyles';
import useFilterStyles from './useFilterStyles';

export default function MultiSelectFilter({
  columnName,
  state,
  dispatch,
  data,
  label,
  placeholder,
}: {
  columnName: string;
  state: any;
  dispatch: Dispatch<any>;
  data: any;
  label: string;
  placeholder: string;
}) {
  const { t } = useIntlLight();
  const [opened, setOpened] = useState(false);
  const defaultValue =
    (state?.filters || [])
      .filter((_filter: any) => {
        return _filter.property.includes(columnName);
      })
      ?.map((filter: any) => {
        return filter?.value;
      }) || [];
  const [value, setValue] = useState(defaultValue || []);
  const { classes } = useFilterStyles({ isFilterEnabled: value?.length >= 1 });
  const isAppliedDisable = value?.length <= 0;

  const handleClose = () => {
    setOpened(false);
  };

  const handleClear = () => {
    state.filters?.forEach((_filterValue: string, key: string) => {
      dispatch({
        type: actionTypes.SET_FILTER,
        payload: { property: `${columnName}[${key}]`, value: '' },
      });
    });
    setValue([]);
    setOpened(false);
  };

  const handleApply = () => {
    handleClear();
    value?.forEach((filterValue: string, key: number) => {
      if (filterValue === undefined) {
        return;
      }
      dispatch({
        type: actionTypes.SET_FILTER,
        payload: { property: `${columnName}[${key}]`, value: filterValue ?? '' },
      });
    });
    setOpened(false);
  };

  return (
    <Popover
      opened={opened}
      onClose={handleClose}
      position="bottom"
      transition="scale-y"
      withinPortal
    >
      <Popover.Target>
        <ActionIcon
          size="sm"
          className={classes.filterIconButton}
          color={value?.length >= 1 ? 'blue' : 'gray'}
          onClick={() => setOpened(o => !o)}
          variant="filled"
        >
          <FilterIcon />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>
        <MultiSelect
          label={label}
          data={data}
          placeholder={placeholder}
          value={value}
          dropdownPosition="top"
          styles={selectDropdownStyles}
          onChange={value => {
            if (value?.length <= 0 && state.filters?.length >= 1) {
              handleClear();
            }

            setValue(value);
          }}
        />
        <Group position="apart" mt="sm">
          <Button color="red" onClick={handleClear} disabled={value?.length <= 0}>
            {t('app.clear')}
          </Button>
          <Button onClick={handleApply} disabled={isAppliedDisable}>
            {t('app.apply')}
          </Button>
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
}
